import { render, staticRenderFns } from "./Sentimentanalys.vue?vue&type=template&id=1ccc89e2"
import script from "./Sentimentanalys.vue?vue&type=script&lang=js"
export * from "./Sentimentanalys.vue?vue&type=script&lang=js"
import style0 from "./Sentimentanalys.vue?vue&type=style&index=0&id=1ccc89e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports